export const FETCH_MEMBER_COURSES_REQUEST = 'fetch_member_courses_request';
export const FETCH_MEMBER_COURSES_SUCCESS = 'fetch_member_courses_success';
export const FETCH_MEMBER_COURSES_FAILURE = 'fetch_member_courses_failure';
export const FETCH_MEMBER_COURSE_REQUEST = 'fetch_member_course_request';
export const FETCH_MEMBER_COURSE_SUCCESS = 'fetch_member_course_success';
export const FETCH_MEMBER_COURSE_FAILURE = 'fetch_member_course_failure';
